import React, { useState } from "react";
import Config from "../../Context/Config";
import Swal from "sweetalert2";

const FileDownloadModal = ({ isOpen, onClose, data, isLoading, setReviewKey }) => {
  const [reviewing, setReviewing] = useState(false);

  if (!isOpen) return null;

  const files = (data?.files && typeof data.files === 'object') ? Object.entries(data.files) : [];
  const apptID = data?.apptID;
  const review = data?.review;
  const form_type = data?.form_type;

  const handleDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename; // Suggests a filename
    link.target = "_blank"; // REMOVE THIS
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleReviewedClick = async () => {
    if (!apptID) return;

    try {
      setReviewing(true);

      const response = await fetch(`${Config.API_BASE_URL}/review_form`, {
        method: "POST",
        headers: {
          "action_id": Config.ACTIONID['edit'],
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
          "practice": localStorage.getItem("digital-form-dept-practice")
        },
        body: JSON.stringify({ apptID, form_type })
      });

      if (!response.ok) throw new Error("Failed to mark reviewed");

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Marked as Reviewed. ",
        confirmButtonText: "OK"
      }).then(() => {
        onClose(); // Close the modal after user clicks OK
        setReviewKey(prev => prev + 1); // Trigger parent refresh
      });

    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error marking as reviewed"
      });
    } finally {
      setReviewing(false);
    }
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 min-w-[300px] max-w-2xl max-h-[80vh] overflow-y-auto shadow-lg relative">
        <h2 className="text-xl font-semibold mb-4">Download Files</h2>

        <button
          onClick={onClose}
          aria-label="Close modal"
          className="absolute top-4 right-4 text-2xl font-bold text-black hover:text-black cursor-pointer"
        >
          &times;
        </button>

        {isLoading ? (
          <p className="text-center">Loading files...</p>
        ) : files.length === 0 ? (
          <p className="text-center">No files found.</p>
        ) : (
          <ul className="space-y-3 mb-4">
            {files.map(([filename, url]) => (
              <li
                key={filename}
                className="flex justify-between items-center"
              >
                <span className="break-words">{filename}</span>
                <button
                  onClick={() => handleDownload(url, filename)}
                  className="mx-3 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                >
                  <i className="fas fa-download"></i>
                </button>
              </li>
            ))}
          </ul>
        )}

        {/* Show Reviewed button only if review is true */}
        {review && (
          <div className="flex justify-center mt-4">
            <button
              onClick={handleReviewedClick}
              disabled={reviewing}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            >
              <i className="fas fa-check-circle"></i>
              {reviewing ? "Marking..." : "Mark as Reviewed"}
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default FileDownloadModal;
